import { type IRestResponse, useClientBuilder } from "@app-rest/index";

import type { IAttraction, IAttractionOffersRequest, IAttractionOffersResponse, IAttractionTimeSlotRequest, IAttractionTimeSlotResponse } from "./attractions.interfaces";

const useRest = useClientBuilder.createRestClient();
useRest().setOption("cacheInMemory", false);

export default function useAttractionsRestClient() {
	const { get, post } = useRest();

	function getAttractionsList(systemId: number) {
		return get<IRestResponse<IAttraction>>(`/${systemId}/attractions-api/attractions`);
	}

	function attractionOffers(systemId: number, data: IAttractionOffersRequest) {
		return post<IAttractionOffersResponse>(
			`${systemId}/attractions-api/itemsAvailability/search`, {
				body: data,
			});
	}

	function attractionTimeSlots(systemId: number, data: IAttractionTimeSlotRequest, abortController?: AbortController) {
		return post<IAttractionTimeSlotResponse>(
			`${systemId}/attractions-api/itemsAvailability/slots/search`, {
				body: data,
				abortController,
			});
	}

	return {
		getAttractionsList,
		attractionOffers,
		attractionTimeSlots
	};
}
